<template>
  <div>
    <a-modal v-model="visible" title="Edit Bundled Product Details" :width="this.settings['isMobileView'] ? 480 : 720"
      onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Edit Bundled Product</a-button>
      </template>
      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input placeholder="Bundled Product Name" v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input bundled product name!',
                },
                { max: 30, message: 'Must not exceed 30 characters!' },
              ],
            },
          ]" />
        </a-form-item>
        <a-form-item label="Bundled Product Code">
          <a-input placeholder="Bundled Product Code. eg: SKU1129930" v-decorator="[
            'code',
            {
              rules: [
                { required: true, message: 'Please input product code!' },
                { max: 30, message: 'Must not exceed 30 characters!' },
              ],
            },
          ]" />
        </a-form-item>

        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{ minRows: 2 }" v-decorator="[
            'description',
            {
              rules: [
                { max: 100, message: 'Must not exceed 100 characters!' },
              ],
            },
          ]" />
        </a-form-item>

        <div class="mt-3">
          <p class="text-uppercase font-weight-bold text-muted">
            Product Groupings
          </p>

          <div class="row mb-4">
            <div class="col-12" v-for="(key, index) in productGroupings" :key="key">
              <div class="d-flex">
                <div class="mr-2 pt-2">
                  <span class="font-weight-bold">{{ index + 1 }}.</span>
                </div>
                <div class="col">
                  <a-form-item>
                    <a-select style="width: 100%" v-decorator="[
                      `product_group[${key - 1}]`,
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a Product!',
                          },
                        ],
                        initialValue: [],
                      },
                    ]" placeholder="Select a product">
                      <a-select-option v-for="product in products" :key="product.id">
                        {{ product.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div class="col">
                  <a-form-item>
                    <a-input-number style="width: 100%" placeholder="Add Quantity"
                      v-decorator="[`quantity[${key - 1}]`, { rules: [{ required: true, message: 'Please input quantity!' }] }]" />
                  </a-form-item>
                </div>

                <div class="ml-2 pt-1">
                  <button class="btn btn-sm btn-danger" @click.prevent="handleRemoveProductGrouping(key)">
                    <i class="btn-addon-icon fe fe-trash-2" />
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="add-button">
                <button class="add-prod" @click.prevent="handleAddProductGrouping">
                  + Add product grouping
                </button>
              </div>
            </div>
          </div>
        </div>

      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { fetchInventoryData } from '@/components/inventory/common'
import { mapState } from 'vuex'
export default {
  name: 'EditProduct',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      categories: [],
      productGroupings: [],
      productCounter: 0,
      productGroups: [],
      prodGroupSpinning: false,
    }
  },
  mounted: function () {
    let d = fetchInventoryData('category')
    d.then((data) => {
      this.categories = data.data
    }).catch((err) => console.error(err))
    this.$eventBus.$on('openEditForm', this.showForm)

    this.getProducts()
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    getProducts: function () {
      this.$http
        .get('/api/inventory/product')
        .then(({ data }) => {
          this.products = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleAddProductGrouping() {
      this.productCounter++
      if (this.productGroupings.length < 10) {
        this.productGroupings.push(this.productCounter)
      }
    },
    handleRemoveProductGrouping(key) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this product grouping.`,
        onOk: () => {
          this.productGroupings = this.productGroupings.filter(
            (item) => item !== key
          )
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    showForm: function (record) {
      this.visible = true
      console.log('passed record', record)
      this.oldrecord = record
      let fieldsWithData = {
        name: record.name,
        description: record.description,
        code: record.code,
        product_id: record.product_group,
        quantity: record.quantity,
        ...this.makeProductGroupData(record),
      }
      setTimeout(() => {
        this.form.setFieldsValue(fieldsWithData)
      }, 50)
    },
    makeProductGroupData(record) {
      this.productCounter = record.products.length
      const fieldData = {}
      this.productGroupings = []
      for (let i = 0; i < record.products.length; i++) {
        this.productGroupings.push(i + 1)
        fieldData[`product_group[${i}]`] = record.products[i].id
        fieldData[`quantity[${i}]`] = record.products[i].pivot.quantity
        // this.form.setFieldsValue({ product_group: record.products[i].id })
      }
      return fieldData
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('old data', this.oldrecord)
          // console.log('formdata', values)
          this.$http
            .patch(`/api/inventory/bundled_product/${this.oldrecord.id}`, {
              name: values.name,
              code: values.code,
              description: values.description,
              status: 1,
              product_id: values.product_group,
              quantity: values.quantity,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Bundled Product details edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description:
                    'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch((error) => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>

<style></style>
